export enum EButtonLocation {
  UnderForm = 0,
  Top = 1,
  Bottom = 2
}

export interface IWorkflowScreenSettings {
  buttonLocation: EButtonLocation;
}
